export const MODIF_RECOM = 'modifier';
export const COPIE_RECOM = 'copier';
export const ARCHIVER_RECOM = 'archiver';
export const DESARCHIVER_RECOM = 'desarchiver';
export const VOIR_DEVIS_ACHAT = 'voirDevisAchat';
